import { ConfirmationResult, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../configs/firebase";
import { useApi } from "./api";
import {
  AccountType,
  LoginDTO,
  RegisterDTO,
  UploadDocumentDTO,
  VerifyAccountDTO,
} from "../models";
import { useContextState } from '../context/Context';
import { useNavigate } from "react-router-dom";

let confirmationResult: ConfirmationResult;

export const useAuth = () => {
  const navigate = useNavigate();

  const { accountCTX } = useContextState();
  const { signedIn, setSignedIn, profile, setProfile, setRequiredDocuments, phoneValidation, setPhoneValidation } = accountCTX
  const { $post, $get } = useApi();

  const verifyAccount = async (credentials: VerifyAccountDTO) => {
    // console.log(credentials)
    const data = await $post( "account/action/check_if_account_exists/", credentials, false );
    // console.log("data", data);
    return data;
  };

  const verifyPhoneNumber = async (credentials: {phoneNumber: string}) => {
    const data = await $post("account/action/generate_otp/", credentials, false);
    // console.log(data);
    if (!data) return;
    if (data.res.res.toLowerCase() === 'success'){setPhoneValidation({...data.data, 'status':'pending'})}
    return data;
  };

  const verifyOtp = async (credentials: {phoneNumber: string, code_id: string}) => {
    const data = await $post("account/action/validate_otp/", credentials, false);
    // console.log(data);
    if (!data) return;
    if (data.res == 'success'){setPhoneValidation({...phoneValidation, 'status':'active'})}
    return data;
  };

  const resetToken = async () => {};

  // const setProfile = (profile: any) => {
  //   window.sessionStorage.setItem("nj_profile", JSON.stringify(profile));
  // };

  // const getProfile = () => {
  //   return JSON.parse(window.sessionStorage.getItem("nj_profile") as string);
  // };

  const login = async (credentials: LoginDTO) => {
    // console.log(credentials)
    const data = await $post("account/signin/", credentials, false);
    // console.log(data);
    if (!data) return;
    if (data.res.toLowerCase() === "success") {
      if (data.status === 'active'){
        const { pic, username, country, name, qr_image, cash, number, card_status, card_qr, notifications_count, bonus, required_document, required_documents_status, res, } = data;
        setSignedIn(true);
        setRequiredDocuments(data.required_document)
        setProfile({
          username,
          country,
          name,
          avatar: pic
            ? pic.includes("//")
              ? pic
              : "http://127.0.0.1:8000" + pic
            : null,
          qr_image,
          cash,
          number,
          card_status,
          card_qr,
          notifications_count,
          bonus,
          required_document,
          required_documents_status,
        });
      }
      else if (data.res == "pending documents"){
        setRequiredDocuments(data.data)
        navigate("/documents")
        // return data
      }
    }
    return {
      isAuth: data.res.toLowerCase() === "success",
      message: data.message,
      remaining_trials: data.remaining_trials,
    };
  };

  const loginSubAccount = async (credentials: any) => {
    const data = await $post("account/signin_sub_account/", credentials, false);
    // console.log(data);
    if (!data) return;
    if (data.res.toLowerCase() === "success") {
      const { tokens, pic, username, name, qr_image, cash, number, card_status, card_qr, notifications_count, bonus, required_document, required_documents_status, } = data;
      setSignedIn(true);
      setProfile({ username, name, avatar: pic, qr_image, cash, number, card_status, card_qr, notifications_count, bonus,  required_document, required_documents_status, });
    }
    return {
      isAuth: data.res.toLowerCase() === "success",
      message: data.message,
      remaining_trials: data.remaining_trials,
    };
  };

  const logout = async (account_type: AccountType) => {
    const data = await $post("account/signout/", { account_type }, false);
    // console.log(data);
    if (!data) return;
    if (data.res.toLowerCase() !== "success") return;
    setSignedIn(false)
    window.localStorage.clear();
    window.sessionStorage.clear();
    return true;
  };

  const register = async (credentials: RegisterDTO) => {
    const data = await $post("account/signup/", credentials, false);
    console.log(data);
    if (!data) return;
    if (data.res.toLowerCase() !== "success") return;
    return data
  };

  const uploadSignupDocument = async (credentials: UploadDocumentDTO) => {
    const data = await $post("account/document/action/upload_document/", credentials, false);
    return data;
  };

  const uploadDocument = async (credentials: UploadDocumentDTO) => {
    const data = await $post("account/upload_document/", credentials, false);
    return data;
  };

  const updatePassword = async (credentials: LoginDTO) => {
    // console.log("credentials", credentials);
    const data = await $post("account/reset_password/", credentials, false);
    if (!data) return;
    // console.log(data);
    return data
  };

  const changeCardPin = async ({ password, pin }: any) => {
    const data = await $post(
      "account/qrcode/update_card_pin/",
      { password, pin },
      false
    );
    console.log(data);
    return { success: data.res === "Success", message: data.message };
  };

  const switchCardStatus = async ({ password }: any) => {
    const data = await $post(
      "account/qrcode/change_card_status/",
      { password },
      false
    );
    console.log(data);
    return { success: data.res === "Success", message: data.message };
  };

  const getCardStatus = async () => {
    const data = await $get("account/qrcode/get_card_status/");
    console.log(data);
    return data?.status;
  };

  const changePseudo = async ({ pseudo, password }: any) => {
    const data = await $post(
      "account/update_pseudo/",
      { pseudo, password },
      false
    );
    console.log(data);
    return { success: data.res === "Success", message: data.message };
  };

  const changePhone = async ({ phone, password }: any) => {
    const data = await $post(
      "account/update_phone/",
      { phone, password },
      false
    );
    console.log(data);
    return { success: data.res === "Success", message: data.message };
  };

  return {
    verifyPhoneNumber,
    verifyAccount,
    resetToken,
    verifyOtp,
    login,
    register,
    updatePassword,
    uploadDocument,
    uploadSignupDocument,
    // getProfile,
    logout,
    changeCardPin,
    switchCardStatus,
    getCardStatus,
    changePseudo,
    changePhone,
  };
};
